<template>
  <div class="wrapper">
    <modal
        name="VmNewNode"
        :draggable="true"
        :resizable="true"
        :clickToClose="false"
        :width="850"
        :min-width="425"
        :min-height="500"
        :height="600"
        :scrollable="true"
        @closed="modalClosed"
        class="modalBox"
        :style="{'--selectHeight': '120px'}"
    >
      <div class="window-header">
        Create new node
        <a href="javascript:void(0)" class="close-modal pull-right" @click="closeModal()"><i
            class="fa fa-times"></i></a>
      </div>
      <div class="modal-body">
        <div class="page-modal" style="background: white;">
          <!--<div class="alert alert-danger alert-dismissable" v-show="error !== ''">
            <strong>Error </strong>
            <div class="errorMsg" style="display: inline-block;">{{ error }}</div>
          </div>-->
          <form class="form-horizontal">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">Name</label>
                  <input
                      :class="{'required-empty-field':formSent && !currentName}"
                      type="text"
                      v-model="currentName"
                      placeholder="Node name"
                      class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">Type</label>
                  <b-form-select
                      :options="typeSelectItems"
                      text-field="label"
                      value-field="value"
                      @change="onTypeSelect"
                      v-model="currentType"
                      placeholder="Select Type.."
                      inputId="Type"
                      clearable
                      maxHeight="50px"/>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">Datacenter</label>
                  <b-form-select
                      :class="{'required-empty-field':formSent && !currentDCid}"
                      :options="DCsSelectItems"
                      text-field="value"
                      value-field="id"
                      @change="onDCselect"
                      placeholder="Select Datacenter .."
                      v-model="currentDCid"
                      inputId="DC"
                      clearable
                      maxHeight="50px"/>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">HyperVisor</label>
                  <b-form-select
                      :class="{'required-empty-field':formSent && !currentHyperVisorId}"
                      :options="HyperVisorsSelectItems"
                      text-field="value"
                      value-field="id"
                      @change="onHyperVisorSelect"
                      v-model="currentHyperVisorId"
                      placeholder="Select HyperVisor.."
                      inputId="HyperVisor"
                      clearable
                      maxHeight="50px"/>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">IP</label>
                  <div style="position: relative;">
                    <b-form-select
                        :class="{'required-empty-field':formSent && !currentIPid}"
                        :options="IPsSelectItems"
                        text-field="value"
                        value-field="id"
                        @change="setIpId"
                        v-model="currentIPid"
                        placeholder="Select IP.."
                        inputId="currentIPid"
                        id="currentIPid"
                        clearable
                        maxHeight="50px"/>
                    <SelectSearch :handler-func="setIpId" field="currentIPid" :options=IPsSelectItems></SelectSearch>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">Node type</label>
                  <b-form-select
                      :options="nodeTypes"
                      :class="{'required-empty-field':formSent && !currentNodeType}"
                      v-model="currentNodeType"
                      placeholder="Select Node type.."
                      inputId="currentNodeType"
                      clearable
                      maxHeight="50px"/>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label class="control-label">ISO-image</label>
                  <b-form-select
                      :options="ISOsSelectItems"
                      v-model="currentIsoImage"
                      placeholder="Select ISO-image.."
                      inputId="currentIsoImage"
                      clearable
                      maxHeight="50px"/>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">Cpu</label>
                  <input
                      :class="{'required-empty-field':formSent && !currentCpu}"
                      type="number"
                      v-model="currentCpu"
                      :placeholder="vm_cpu_placeholder"
                      :xmax="vm_cpu_max"
                      :min="0"
                      class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">Ram</label>
                  <input
                      :class="{'required-empty-field':formSent && !currentRam}"
                      type="number"
                      v-model="currentRam"
                      :placeholder="vm_ram_placeholder"
                      :min="vm_ram_min"
                      :xmax="vm_ram_max"
                      class="form-control"
                  />
                </div>
              </div>
            </div>

          </form>
        </div>
      </div>
      <div class="modal-footer">
        <button @click="submitNewNode(true)" class="btn btn-secondary">Create and Add more</button>
        <button @click="submitNewNode()" class="btn btn-primary">Create node</button>
        <button
            class="btn btn-default"
            href="javascript:void(0);"
            v-on:click="closeModal()"
            type="button"
        >
          <span>Cancel</span>
        </button>
      </div>
    </modal>

    <ModalError name="VmNewNodeError" :message="error"/>

  </div>
</template>

<script>

import axios from 'axios';
import ModalError from './ModalError.vue';
import _ from 'lodash'
import SelectSearch from "@/components/filters/SelectSearch.vue";
import {TokenMixin} from '@/assets/js/mixins/token-mixin';
import {ErrorsMixin} from "@/assets/js/mixins/errors-mixin";

export default {
  name: 'VmNewNode',
  mixins: [
    TokenMixin,
    ErrorsMixin,
  ],
  components: {
    SelectSearch,
    ModalError,
  },
  props: [
    'type',
    'itemId',
    'successCreateCallback',
    'DcId',
    'ServerId',
    'ServerName',
    'cloneItem'
  ],
  emits: ['loadData'],
  data() {
    return {
      submitNewNodeUrl: '/api/manager/vm/',
      loadDCsUrl: '/api/manager/dc/list?sort=-FreeIp',
      loadIPsUrl: '/api/manager/ip/list?sort=-DiscoveredAt',
      loadHyperVisorsUrl: 'api/manager/server/list?sort=name',
      loadTypesUrl: 'api/manager/vm-entities',
      loadISOsUrl: '/api/launcher/content?parsed=y',
      apiConfig: '/api/config/item-form/',
      login: '/login',

      formSent: false,
      currentName: '',
      currentType: 0,
      DCs: {},
      DCsSelectItems: [],
      currentDCid: 0,
      Nets: {},
      NetsSelectItems: [],
      currentNetId: '',
      IPs: {},
      IPsSelectItems: [],
      ISOsSelectItems: [],
      types: [],
      currentIPid: '',
      HyperVisors: {},
      HyperVisorsSelectItems: [],
      currentHyperVisorId: 0,
      nodeTypes: [
        'p2p',
        'astro',
        'prx'
      ],
      currentNodeType: '',
      currentCpu: '',
      currentRam: '',
      currentIsoImage: '',

      vm_ram_min: 4,
      vm_ram_max: 0,
      vm_ram_placeholder: '',
      vm_cpu_min: 0,
      vm_cpu_max: 0,
      vm_cpu_placeholder: '',

      // service
      error: '',
      success: '',
      loading: 'loaded',
    }
  },
  methods: {
    async init() {
      console.log("vm new node Init");
      this.currentName = this.cloneItem.Name ?? '';
      this.currentDCid = 0;
      this.currentNetId = '';
      this.currentIPid = this.cloneItem.IpDcId ?? '';
      this.currentHyperVisorId = 0;
      this.currentNodeType = this.cloneItem.VmType ?? '';
      this.currentCpu = this.cloneItem.Cpu ?? '';
      this.currentRam = this.cloneItem.Ram ?? '';
      this.currentIsoImage = this.cloneItem.VmIso ?? '';
      this.currentType = this.cloneItem.Entity ?? 0
      this.vm_ram_min = this.cloneItem.name ?? 4;
      this.vm_ram_max = this.cloneItem.name ?? 0;
      this.vm_ram_placeholder = this.cloneItem.name ?? '';
      this.vm_cpu_min = this.cloneItem.name ?? 0;
      this.vm_cpu_max = this.cloneItem.name ?? 0;
      this.vm_cpu_placeholder = this.cloneItem.name ?? '';

      await this.loadDCs();
      if (this.cloneItem.IpDcId) {
        console.log("cloneItem.IpDcId", this.cloneItem.IpDcId, this.cloneItem);
        this.currentDCid = parseInt(this.cloneItem.IpDcId);
      } else if (parseInt(this.DcId) !== 0) {
        this.currentDCid = this.DcId;
      }
      await this.loadHyperVisorByNet();
      if (parseInt(this.ServerId) !== 0) {
        this.currentHyperVisorId = this.ServerId;
        this.loadIPsByDC();
      }
      if (this.ServerName !== "") {
        let filteredServer = this.HyperVisors.find(hv => hv.Name === this.ServerName);
        if (filteredServer) {
          this.currentHyperVisorId = parseInt(filteredServer.Id);
        }
        this.loadIPsByDC();
      }
      if (this.cloneItem.ServerId) {
        this.currentHyperVisorId = this.cloneItem.ServerId;

        this.loadHyperVisorByNet().then(() => {
          if (this.HyperVisors.length > 0) {
            let current_hv = this.HyperVisors.find(hv => hv.Id === this.currentHyperVisorId);
            this.genVMresourcesLimitsByHyperVisor(current_hv);
            this.loadIPsByDC();
          }
        });
      }
      if (parseInt(this.ServerId) !== 0) {
        this.currentHyperVisorId = this.ServerId;
        await this.loadHyperVisorByNet();
      }
    },
    clearValues() {
      this.currentName = '';
      this.currentNetId = '';
      this.currentIPid = '';
      this.currentNodeType = '';
      this.currentCpu = '';
      this.currentRam = '';
      this.currentIsoImage = '';
      this.currentType = ''
      this.vm_ram_min = 4;
      this.vm_ram_max = 0;
      this.vm_ram_placeholder = '';
      this.vm_cpu_min = 0;
      this.vm_cpu_max = 0;
      this.vm_cpu_placeholder = '';
      this.DCs = []
      this.HyperVisors = '';
      this.currentDCid = 0;
      this.currentHyperVisorId = 0;
      this.IPs = '';
      this.currentIPid = '';

    },
    loadDCs() {
      let loader = this.$loading.show();
      axios.post(this.loadDCsUrl, [], this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.loading = 'loaded';
            this.errorHandle(err);
          })
          .then(res => {
            loader.hide();
            this.loading = 'loaded';
            if (res.data.data !== undefined) {
              this.DCs = res.data.data;
              this.genDCsSelectItems();
            }
          })
    },

    genDCsSelectItems() {
      this.DCsSelectItems = [];
      this.DCs.forEach((dc) => {
        let servers = (dc.ServerCount === null)?"0":dc.ServerCount
        let vms = (dc.VmCount === null)?"0":dc.VmCount
        let select_option_text = `${dc.Name}, ${servers} Servers, ${vms} VMs, ${dc.FreeIp}/${dc.AllIp} Free IPs`;
        let select_option = {id: dc.Id, value: select_option_text};
        this.DCsSelectItems.push(select_option);
      });
    },
    onTypeSelect($event) {
      console.log("onTypeSelect $event",$event);
      console.log("onTypeSelect currentType",this.currentType);
      //this.currentType = $event?.value || $event
    },
    onDCselect($event) {
      console.log("onDcSelect $event", $event);
      console.log("onDcSelect currentDCid", this.currentDCid);
      this.currentDCid = $event
      this.loadHyperVisorByNet();
    },
    getIpID() {
      const index = this.IPsSelectItems.find(item => item.id === this.currentIPid)
      return this.IPsSelectItems[index]
    },
    setIpId($event) {
      console.log("setIpId $event", $event);
      console.log("setIpId currentIPid before", this.currentIPid);
      if ($event != null && $event != this.currentIPid) {
        let foundedIp = this.IPsSelectItems?.find(ips => ips.value === $event);
        if (foundedIp == null) {
          return;
        }
        let parsedId = parseInt(foundedIp.id);
        if (parsedId > 0) {
          this.currentIPid = parsedId;
        }
      }
      console.log("setIpId currentIPid after", this.currentIPid);
    },
    genNetsSelectItems() {
      this.NetsSelectItems = [];
      this.Nets.forEach((net) => {
        let select_option_text = `${net.Address}, ${net.FreeIp}/${net.AllIp} Free IPs`;
        let select_option = {id: net.Id, value: select_option_text};
        this.NetsSelectItems.push(select_option);
      });
    },

    loadIPsByDC() {
      console.log('loadIP')
      let loader = this.$loading.show();
      if (this.currentHyperVisorId == 0) {
        loader.hide();
        this.loading = 'loaded';
        return;
      }
      let urlIp = this.loadIPsUrl;
      axios.post(urlIp,
          [
            {
              "Condition": "=",
              "Data": {
                "DcId": this.currentDCid
              }
            },
            {
              "Condition": "=",
              "Data": {
                "UsedByEntityOrVm": "none"
              }
            },
          ],
          this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.loading = 'loaded';
            this.moveUp();
            this.errorHandle(err);
          })
          .then(res => {
            loader.hide();
            this.loading = 'loaded';
            if (res.data.data !== undefined) {
              console.log(res.data.data)
              this.IPs = res.data.data;
              this.genIPsSelectItems();
            }
          })
    },

    genIPsSelectItems() {
      this.IPsSelectItems = [];
      this.IPs.forEach((ip) => {
        let network = `, network: ${ip.Network}`;
        if (ip.Network === undefined || ip.Network === null ) {
          network = ""
        }
        let linked = `, linked: ${ip.ServerName}`;
        if (ip.ServerName === undefined || ip.ServerName === null ) {
          linked = ", linked: nobody"
        }
        let select_option_text = `${ip.Address}${network}, state: ${ip.State}, DC: ${this.currentDCname}${linked}, used by nobody`;
        let select_option = {id: ip.Id, value: select_option_text};
        this.IPsSelectItems.push(select_option);
      });
    },
    genISOsSelectItems() {
      this.ISOsSelectItems = [];
      let loader = this.$loading.show();
      axios.post(this.loadISOsUrl,
          {
            "name": "isolist"
          },
          this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.loading = 'loaded';
            this.moveUp();
            this.errorHandle(err);
          })
          .then(res => {
            loader.hide();
            this.loading = 'loaded';
            if (res.data.data !== undefined) {
              this.ISOsSelectItems = res.data.data;
            }
          });
    },

    loadHyperVisorByIP() {
      let loader = this.$loading.show();
      axios.post(this.loadHyperVisorsUrl,
          [
            {
              "Condition": "=",
              "Data": {
                "IpId": this.currentIPid
              }
            },
            {
              "Condition": "=",
              "Data": {
                "Entity": [0,4]
              }
            }
          ],
          this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.loading = 'loaded';
            this.moveUp();
            this.errorHandle(err);
          })
          .then(res => {
            loader.hide();
            this.loading = 'loaded';
            if (res.data.data !== undefined) {
              console.log(res.data.data)
              this.HyperVisors = res.data.data;
              this.genHyperVisorsSelectItems();
            }
          })
    },
    loadTypes() {
      let loader = this.$loading.show();
      axios.get(this.loadTypesUrl, this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.loading = 'loaded';
            this.moveUp();
            this.errorHandle(err);
          })
          .then(res => {
            loader.hide();
            this.loading = 'loaded';
            if (res.data.data !== undefined) {
              console.log('types: ', res.data.data)
              this.types = res.data.data;
            }
          })
    },
    loadHyperVisorByNet() {
      let loader = this.$loading.show();
      let filterHyperVisors = [];
      filterHyperVisors.push({
        "Condition": "=",
        "Data": {
          "Entity": [0,4]
        }
      });
      let filterByDc = {
        "Condition": "=",
        "Data": {
          "DcId": this.currentDCid
        }
      }
      if (this.currentDCid !== 0) {
        filterHyperVisors.push(filterByDc);
      }
      return axios.post(this.loadHyperVisorsUrl, filterHyperVisors, this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.loading = 'loaded';
            this.moveUp();
            this.errorHandle(err);
          })
          .then(res => {
            loader.hide();
            this.loading = 'loaded';
            if (res.data.data !== undefined) {
              this.HyperVisors = res.data.data;
              this.genHyperVisorsSelectItems();
              if (parseInt(this.ServerId) !== 0) {
                this.onHyperVisorSelect();
              }
            }
          })
    },

    genHyperVisorsSelectItems() {
      this.HyperVisorsSelectItems = [];
      this.HyperVisors.forEach((hv) => {
        let usedMem = parseInt(hv.VmSum);
        let fullMem = parseInt(hv.Ram);
        let freeMem = fullMem - usedMem;
        let ssdCount = (hv.Ssd === null)?"0":hv.Ssd
        let hddCount = (hv.Hdd === null)?"0":hv.Hdd
        let select_option_text = `${hv.Name} ${hv.Model}, CPU: ${hv.Cpu}/${hv.MaxCpu}, VmRAM: ${usedMem}/${fullMem} (${freeMem}), SSD: ${ssdCount}, HDD: ${hddCount}`;
        let select_option = {id: hv.Id, value: select_option_text};
        this.HyperVisorsSelectItems.push(select_option);
      });
    },
    //
    onHyperVisorSelect($event) {
      if ($event === undefined) return;
      console.log("onHyperVisorSelect $event", $event);
      console.log("onHyperVisorSelect currentHyperVisorId", this.currentHyperVisorId);
      //this.currentHyperVisorId = $event.id
      let current_hv = this.HyperVisors?.find(hv => hv.Id === this.currentHyperVisorId);
      this.genVMresourcesLimitsByHyperVisor(current_hv);
      if (this.currentDCid === 0 && this.DCs.length > 0) {
        let currentDC = this.DCs.find(dc => dc.Id == current_hv.DcId);
        if (currentDC) {
          this.currentDCid = parseInt(currentDC.Id);
        }
      }
      this.loadIPsByDC();
    },


    genVMresourcesLimitsByHyperVisor(hypervisor) {
      this.vm_ram_max = hypervisor.Ram - 17;
      this.vm_ram_placeholder = `From ${this.vm_ram_min} to ${this.vm_ram_max}`;
      this.vm_cpu_max = hypervisor.Cpu;
      this.vm_cpu_placeholder = `From ${this.vm_cpu_min} to ${this.vm_cpu_max} (${this.vm_cpu_max} is optimal)`;
    },

    submitNewNode(addMore = false) {
      this.formSent = true;
      if (!this.currentName || !this.currentNodeType || !this.currentIPid || !this.currentHyperVisorId || !this.currentDCid) {
        alert("Fill the fields");
        return;
      }
      let data = {
        Id: null,
        Name: this.currentName,
        State: 'CREATED',
        VmType: this.currentNodeType,
        ServerId: this.currentHyperVisorId,
        Entity: parseInt(this.currentType),
        IpId: this.currentIPid,
        Mac: this.currentIPmac,
        Cpu: parseInt(this.currentCpu),
        Ram: parseInt(this.currentRam),
        VmIso: this.currentIsoImage,
        ProjectId: null,
        Comment: '',
        DiscoveredAt: '2021-12-03 06:28:57', //TODO обнулить позже
      };
      if (data.Cpu < 1 || data.Ram < 1) {
        alert("Cpu and Ram must be more than 0");
        return;
      }
      if (this.HyperVisors.length === 0) {
        alert("HyperVisors must be more than 0");
        return;
      }
      let current_hv = this.HyperVisors.find(hv => hv.Id === data.ServerId);
      if ((parseInt(data.Ram) + parseInt(current_hv.VmSum)) > parseInt(current_hv.Ram)) {
        alert("Please check Ram value,  max available: " + (parseInt(current_hv.Ram) - parseInt(current_hv.VmSum)));
        //return; // stop form sending
      }

      axios.post(this.submitNewNodeUrl, data, this.authRespConf())
          .then(() => {
            if (!addMore) {
            this.$root.$emit('onCreateNodeSuccess');
            this.$bvToast.toast('VM form', {
              title: 'Node succesfully created',
              autoHideDelay: 5000,
              variant: 'info',
              appendToast: true
            })
            this.$emit('loadData')
            this.closeModal();
            }
            this.init();
          })
          .catch((err) => {
            this.moveUp();
            this.errorHandle(err, true, true, `New VM error`);
          });
    },
    closeModal() {
      this.$modal.hide('VmNewNode');
    },
    moveUp() {
      window.scrollTo(0, 0);
    },
    checkMem() {
      if (this.currentRam < 0) {
        this.currentRam = 0;
      }
    },
    checkCpu() {
      if (this.currentCpu < 0) {
        this.currentCpu = 0;
      }
    },
    modalClosed() {
      this.clearValues()
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    'DcId': 'init',
    'ServerId': 'init',
    'currentRam': 'checkMem',
    'currentCpu': 'checkCpu',
    cloneItem: function () {
      this.init()
    }
  },
  computed: {
    typeSelectItems() {
      return _.map(this.types, (type, index) => {
        return {
          value: index,
          label: type
        }
      })
    },
    getTypeValue() {
      return this.typeSelectItems.find(item => parseInt(item.value) === parseInt(this.currentType))
    },
    getHyperVisorValue() {
      return this.HyperVisorsSelectItems.find(item => item.id === this.currentHyperVisorId)
    },
    getDCValue() {
      console.log("typeSelectItems", this.DCsSelectItems.find(item => item.id === this.currentDCid));
      return this.DCsSelectItems.find(item => item.id === this.currentDCid)
    },
    currentIPmac: function () {
      if (this.IPs?.length > 0) {
        let currentIP = this.IPs.find(ip => ip.Id === this.currentIPid);
        return currentIP.Mac;
      }

      return ''
    },
    currentDCname() {
      let currentDCid = this.DCs.find(dc => dc.Id == this.currentDCid);
      if (!currentDCid) return;
      return currentDCid.Name;
    },
  },
  created: function () {
    this.loadTypes();
    this.genISOsSelectItems();
  }
}
</script>
